import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface ActivitySummary {
  events_today: number
  active_sites_24h: number
  failed_logins_24h: number
  inactive_sites: number
}

export function useActivitySummary() {
  return useQuery({
    queryKey: ['activity-summary'],
    queryFn: async () => {
      return apiClient.get<ActivitySummary>('/api/auth-server/activity-logs/summary')
    },
    refetchInterval: 60000, // Refresh every minute
  })
}
